module.exports = __webpack_public_path__ + "img/20 Aniamtion 3-squashed.e4ff79b0.jpg";